<div class="container-fluid service-bg">
    <div class="row">
        <div class="col-md-12 from-top pb-0">
            <!-- Welcome Message -->
            <h1 class="text-center text-style">{{'lf_register_btn' | translate}}</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <mat-horizontal-stepper class="register-stepper" labelPosition="bottom" #stepper linear>
                <!-- Main Info -->
                <mat-step [stepControl]="registerGroup" [editable]="false">
                    <!-- Welcome Message -->
                    <h3 class="text-center">{{'lf_register_step1_msg' | translate}}</h3>
                    <!-- Register Form -->
                    <div class="form-group mx-auto login-form" [formGroup]="registerGroup">

                        <mat-form-field class="form-element" appearance="fill">
                            <mat-label>{{'gen_email' | translate}}</mat-label>
                            <input [type]="'email'" matInput placeholder="{{'gen_email' | translate}}"
                                formControlName="email">
                            <!-- Errors -->
                            <mat-error *ngIf="registerGroup.controls.email.errors?.required">{{'error_required_error' |
                                translate}}</mat-error>
                            <mat-error *ngIf="registerGroup.controls.email.errors?.pattern">{{'error_email_invalid' |
                                translate}}</mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-element" appearance="fill">
                            <mat-label>{{'gen_password' | translate}}</mat-label>
                            <input [type]="hide ? 'password' : 'text'" matInput
                                placeholder="{{'gen_password' | translate}}" formControlName="password">
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}
                            </mat-icon>

                            <!-- Errors -->
                            <mat-error *ngIf="registerGroup.controls.password.errors?.required">{{'error_required_error'
                                | translate}}</mat-error>
                            <mat-error *ngIf="registerGroup.controls.password.errors?.pattern">{{'error_password_regex'
                                | translate}}</mat-error>
                        </mat-form-field>

                        <!-- Coupon -->
                        <mat-form-field class="form-element" appearance="fill">
                            <mat-label>{{'gen_coupon' | translate}}</mat-label>
                            <textarea class="in-text-areas" matInput placeholder="{{'gen_coupon' | translate}}"
                                formControlName="coupon"></textarea>
                        </mat-form-field>

                        <section class="form-element">
                            <mat-checkbox formControlName="privacy">{{'lf_terms_msg' | translate}}
                                <a href="#/terms">{{'lf_terms_title' | translate}}</a>
                            </mat-checkbox>
                        </section>

                        <button class="button w-100" (click)="register(stepper)"
                            [disabled]="registerGroup.controls.email.status == 'INVALID' || registerGroup.controls.password.status == 'INVALID' || registerGroup.controls.privacy.status == 'INVALID'">
                            <i class="pr-1 fas fa-arrow-right"></i>
                            {{'gen_next' | translate}}
                        </button>
                    </div>
                </mat-step>

                <!-- Validate PIN -->
                <mat-step [stepControl]="mailGroup" [editable]="false">
                    <!-- Verification PIN -->
                    <div class="text-center">
                        <h3>{{'lf_register_step2_msg' | translate}}</h3>

                        <p> {{'lf_register_pin_msg' | translate:{ email: registerGroup.controls.email.value} }} </p>

                        <!-- Count Down Message -->
                        <p *ngIf="countDown > 0">
                            {{'lf_register_pin_msg_2' | translate}} {{countDownTime}}
                            <mat-progress-spinner class="count-down" [color]="'primary'" [mode]="'determinate'"
                                [diameter]="30" [value]="countDown">
                            </mat-progress-spinner>
                        </p>

                        <!-- Expiration Message -->
                        <p *ngIf="countDown <=0"> {{'lf_register_expire_pin_msg' | translate}}
                            <span class="cursor-po-c text-danger"
                                (click)="register(stepper)">{{'lf_register_pin_try_again' | translate}}</span>
                        </p>
                    </div>


                    <!-- Verification PIN Form -->
                    <div class="form-group mx-auto login-form" [formGroup]="mailGroup">
                        <mat-form-field class="form-element" appearance="fill">
                            <mat-label>PIN</mat-label>
                            <textarea class="in-text-areas" matInput formControlName="pin" placeholder="PIN"></textarea>
                            <!-- Errors -->
                            <mat-error *ngIf="mailGroup.controls.pin.errors?.required">{{'error_required_error' |
                                translate}}</mat-error>
                        </mat-form-field>

                        <button class="button w-100" (click)="validatePin(stepper)"
                            [disabled]="mailGroup.controls.pin.status == 'INVALID'">
                            <i class="pr-1 fa fa-sign-in-alt"></i>
                            {{'lf_email_pin_btn' | translate}}
                        </button>

                        <div class="text-center mt-3">
                            <p>{{'lf_register_pin_try_again_msg' | translate}}</p>
                            <p class="cursor-po-c text-danger" (click)="register(stepper)">{{'lf_register_pin_try_again'
                                | translate}}</p>
                        </div>
                    </div>
                </mat-step>

                <!-- End Register -->
                <mat-step>
                    <!-- Products -->
                    <div class="from-top-container">
                        <app-products-list *ngIf="stepper.selectedIndex == 2"></app-products-list>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </div>

        <!-- Go Back to Login -->
        <div class="row pt-5">
            <div class="col-md-12">
                <p class="text-right">
                    <a href="#/login">
                        {{'register_go_to_login' | translate}}
                    </a>
                </p>
            </div>
        </div>

    </div>
</div>